var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyStyle"},[_c('img',{staticClass:"fb-map",attrs:{"src":_vm.getImgUrl(_vm.imgName),"alt":"empty"}}),_c('p',{staticClass:"titleStyle green"},[_vm._v(_vm._s(_vm.textGreen))]),_c('p',{staticClass:"titleStyle grey"},[_vm._v(_vm._s(_vm.textGrey))])])
}
var staticRenderFns = []

export { render, staticRenderFns }